import { defineComponent as _defineComponent } from 'vue'
import advisorAvatar from '@/assets/images/advisor-avatar.png'

    interface Props {
        text: string
        image?: string
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'adviceBubble',
  props: {
    text: null,
    image: { default: advisorAvatar }
  },
  setup(__props: any) {

    

return { __sfc: true, }
}

})